import React from 'react'
import List from '@material-ui/core/List'
import Collapse from '@material-ui/core/Collapse'
import * as s from './styles'

type Props = {
  isOpen: boolean
  submenu?: ISubitem[]
  submenuTitle?: ISubitemTitle[]
  notification?: boolean
  active?: boolean
  disabled?: boolean
}

interface ISubitem {
  text: string
  active?: boolean
  disabled?: boolean
  handleEvent: Function
  notification?: boolean
}

interface ISubitemTitle {
  disabled?: boolean
  title: string
  subitem: ISubitem[]
  notification?: boolean
}

export default function Submenu(props: Props): JSX.Element {
  return (
    <Collapse in={props.isOpen} timeout="auto" unmountOnExit>
      {props.submenu && (
        <s.Container>{renderSubmenu(props.submenu)}</s.Container>
      )}

      {props.submenuTitle &&
        props.submenuTitle?.map((itemTitle, key) => (
          <s.Container key={key}>
            <s.Title>{itemTitle.title}</s.Title>

            {renderSubmenu(itemTitle.subitem)}
          </s.Container>
        ))}
    </Collapse>
  )
}

export function renderSubmenu(submenu: ISubitem[]) {
  return submenu.map((subitem, key) => (
    <List component="div" disablePadding key={key}>
      <s.Submenu notification={subitem.notification}>
        <s.Button
          onClick={() => !subitem.disabled && subitem.handleEvent()}
          disabled={subitem.disabled}
        >
          <s.SubItem
            active={!!subitem?.active}
            className={subitem.disabled ? 'is-disabled' : ''}
          >
            {subitem.text}
            {subitem.notification && (
              <s.WrapperNotification notification={subitem.notification} />
            )}
          </s.SubItem>
        </s.Button>
      </s.Submenu>
    </List>
  ))
}
